var MemberList = require('memberlist');


var MemberHalfOpList = MemberList.extend({
    modeCategory: 'HALFOP'
});


module.exports = MemberHalfOpList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/memberhalfoplist.js
// module id = rPHv
// module chunks = 1